var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTopWinners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_2493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38299 14.0681H4.67239C4.38333 14.0681 4.14899 14.3025 4.14899 14.5915V19.4766C4.14899 19.7656 4.38333 20 4.67239 20H9.38299V14.0681Z",
    fill: "#3AACE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9218 10.957C13.8383 10.957 13.7549 10.9371 13.6782 10.8969L12.0017 10.0153L10.3248 10.8969C10.1486 10.9891 9.93496 10.9746 9.77346 10.857C9.61227 10.74 9.53152 10.5415 9.56524 10.345L9.88586 8.478L8.52896 7.15569C8.36443 6.9955 8.32118 6.74366 8.43255 6.53419C8.51271 6.38344 8.66574 6.28516 8.83471 6.26059L10.6938 5.99044L11.5324 4.29159C11.6204 4.11313 11.8024 4 12.0017 4C12.2011 4 12.383 4.11312 12.4709 4.29169L13.3095 5.99053L15.184 6.26297C15.381 6.29159 15.5449 6.42975 15.6066 6.61922C15.6679 6.80869 15.6168 7.01672 15.474 7.15575L14.1174 8.47806L14.4377 10.3453C14.4715 10.5415 14.3907 10.74 14.2295 10.8571C14.1382 10.9233 14.0302 10.957 13.9218 10.957Z",
    fill: "#FFE14D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0936 11.9745H9.9064C9.61734 11.9745 9.383 12.2089 9.383 12.498V20H14.617V12.498C14.617 12.2089 14.3827 11.9745 14.0936 11.9745Z",
    fill: "#F37B2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3276 16.1617H14.617V20H19.3276C19.6167 20 19.851 19.7657 19.851 19.4766V16.6852C19.851 16.3961 19.6167 16.1617 19.3276 16.1617Z",
    fill: "#7FB335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0936 11.9745H12V20H14.617V12.498C14.617 12.2089 14.3827 11.9745 14.0936 11.9745Z",
    fill: "#E56722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.184 6.26297L13.3095 5.99053L12.4709 4.29169C12.3828 4.11269 12.2002 3.99947 12.0002 4C12.0002 4.0001 12.0001 4.00013 12 4.00025V10.0163L12.0017 10.0153L13.6783 10.8969C13.7549 10.9371 13.8384 10.957 13.9219 10.957C14.0302 10.957 14.1383 10.9233 14.2296 10.857C14.3908 10.74 14.4715 10.5415 14.4378 10.3452L14.1175 8.47803L15.474 7.15572C15.6168 7.01672 15.6679 6.80866 15.6066 6.61919C15.5449 6.42978 15.381 6.2916 15.184 6.26297Z",
    fill: "#FFCC33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_2493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopWinners);
export default __webpack_public_path__ + "static/media/icon_top_winners.84943d7202e8867c65a4c7e3df6154fa.svg";
export { ForwardRef as ReactComponent };